<template>
  <div>
    <div>
      <div><strong><small>Flat (Common Buttons)</small></strong></div>
      <md-button>Default</md-button>
      <md-button class="md-accent">Accent</md-button>
      <md-button disabled>Disabled</md-button>

      <md-button class="md-primary">Primary</md-button>
      <md-button class="md-warning">Warning</md-button>
      <md-button class="md-error">Error</md-button>
      <md-button class="md-success">Success</md-button>


      <div><strong><small>Flat (Icon Buttons)</small></strong></div>
      <md-button class="md-icon-button">
        <md-icon>home</md-icon>
      </md-button>

      <md-button class="md-icon-button md-accent">
        <md-icon>thumb_up</md-icon>
      </md-button>

      <md-button class="md-icon-button" disabled>
        <md-icon>add</md-icon>
      </md-button>

      <md-button class="md-icon-button md-primary">
        <md-icon>menu</md-icon>
      </md-button>
      <md-button class="md-icon-button md-warning">
        <md-icon>home</md-icon>
      </md-button>
      <md-button class="md-icon-button md-error">
        <md-icon>home</md-icon>
      </md-button>
      <md-button class="md-icon-button md-success">
        <md-icon>home</md-icon>
      </md-button>
    </div>
    <hr />
    <div>
      <div><strong><small>Raised (Common Buttons)</small></strong></div>

      <md-button class="md-raised">Default</md-button>
      <md-button class="md-raised md-accent">Accent</md-button>
      <md-button class="md-raised" disabled>Disabled</md-button>

      <md-button class="md-raised md-primary">Primary</md-button>
      <md-button class="md-raised md-warning">Warning</md-button>
      <md-button class="md-raised md-error">Error</md-button>
      <md-button class="md-raised md-success">Success</md-button>

      <div><strong><small>Raised (Icon Buttons)</small></strong></div>
      <md-button class="md-icon-button md-raised">
        <md-icon>home</md-icon>
      </md-button>

      <md-button class="md-icon-button md-raised md-accent">
        <md-icon>thumb_up</md-icon>
      </md-button>

      <md-button class="md-icon-button md-raised" disabled>
        <md-icon>add</md-icon>
      </md-button>

      <md-button class="md-icon-button md-raised md-primary">
        <md-icon>menu</md-icon>
      </md-button>
      <md-button class="md-icon-button md-raised md-warning">
        <md-icon>home</md-icon>
      </md-button>
      <md-button class="md-icon-button md-raised md-error">
        <md-icon>home</md-icon>
      </md-button>
      <md-button class="md-icon-button md-raised md-success">
        <md-icon>home</md-icon>
      </md-button>
    </div>
    <hr />
    <div>
      <div><strong><small>Outlined (Common Buttons)</small></strong></div>

      <md-button class="md-outlined">Default</md-button>
      <md-button class="md-outlined md-accent">Accent</md-button>
      <md-button class="md-outlined" disabled>Disabled</md-button>

      <md-button class="md-outlined md-primary">Primary</md-button>
      <md-button class="md-outlined md-warning">Warning</md-button>
      <md-button class="md-outlined md-error">Error</md-button>
      <md-button class="md-outlined md-success">Success</md-button>

      <div><strong><small>Outlined (Icon Buttons)</small></strong></div>
      <md-button class="md-icon-button  md-outlined">
        <md-icon>home</md-icon>
      </md-button>

      <md-button class="md-icon-button md-outlined md-accent">
        <md-icon>thumb_up</md-icon>
      </md-button>

      <md-button class="md-icon-button md-outlined" disabled>
        <md-icon>add</md-icon>
      </md-button>

      <md-button class="md-icon-button md-outlined md-primary">
        <md-icon>menu</md-icon>
      </md-button>
      <md-button class="md-icon-button md-outlined md-warning">
        <md-icon>home</md-icon>
      </md-button>
      <md-button class="md-icon-button md-outlined md-error">
        <md-icon>home</md-icon>
      </md-button>
      <md-button class="md-icon-button md-outlined md-success">
        <md-icon>home</md-icon>
      </md-button>
    </div>
    <hr />
    <div>
      <div><strong><small>Text and Icon</small></strong></div>
      <md-button class="md-text-and-icon md-primary"><md-icon>home</md-icon>Flat</md-button>
      <md-button class="md-text-and-icon md-raised md-primary"><md-icon>add</md-icon>Raised</md-button>
      <md-button class="md-text-and-icon md-outlined md-primary"><md-icon>edit</md-icon>Outlined</md-button>
    </div>
    <hr />
    <div>
      <div><strong><small>Dense (Common)</small></strong></div>
      <md-button class="md-dense md-primary">Flat</md-button>
      <md-button class="md-dense md-raised md-primary">Raised</md-button>
      <md-button class="md-dense md-outlined md-primary">Outlined</md-button>

      <div><strong><small>Dense (Icons)</small></strong></div>
      <md-button class="md-icon-button md-dense md-primary">
        <md-icon>person</md-icon>
      </md-button>

      <md-button class="md-icon-button md-dense md-raised md-primary">
        <md-icon>cached</md-icon>
      </md-button>

      <md-button class="md-icon-button md-dense md-outlined md-primary">
        <md-icon>cached</md-icon>
      </md-button>
    </div>

    <div>
      <div><strong><small>Ripple Off (Common)</small></strong></div>

      <md-button :md-ripple="false">Flat</md-button>
      <md-button class="md-raised md-primary" :md-ripple="false">Raised</md-button>
      <md-button class="md-outlined md-primary" :md-ripple="false">Outlined</md-button>
    </div>
  </div>
</template>

<script>
  export default {
  }
</script>

<style scoped>
</style>
